<template>
    <div
      @drop.prevent="drop"
      @dragover.prevent="onDragOver"
      @dragleave="onDragLeave"
      ref="container"
    >
      <div class="imagePreviewWrapper" @click="selectImage">
        <div class="flex justify-center">
          <img
            src="@/assets/images/icons/store-icon.svg"
            class="img-fluid img-upload-icon"
            alt="image upload icon"
          />
        </div>
        Drag and drop files here<br />
        OR
      </div>
      <div class="text-center">
        <base-button
          text="Browse Files"
          class="my-2"
          @click="$refs.fileInput.click()"
        />
        <small
          class="text-red font-semibold d-block cursor-pointer opacity-50"
          @click="removeImage"
          >*supported file type: pdf, doc, xlsx, csv, ppt and png or jpg.</small
        >
        <small class="opacity-50">Please select an image smaller than 1MB.</small>
      </div>
      <div v-if="isUploadingImage" class="d-flex justify-content-center py-2">
        <saving-loader :icon-color="'#0253B3'" />
      </div>
      <input
        ref="fileInput"
        type="file"
        @input="pickFile"
        accept=".pdf,.doc,.docx,.xlsx,.csv,.ppt,.pptx,.png,.jpg,.jpeg"
        class="file-input"
      />
    </div>
  </template>
  
  <script>
  import SavingLoader from "@/components/UI/ButtonSavingLoader";
  
  export default {
    props: {
      imageUrl: {
        required: false,
        default: "",
      },
      isUploadingImage: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    components: {
      SavingLoader,
    },
    data() {
      return {
        previewImage: null,
        fileSize: 0,
      };
    },
    methods: {
      drop(event) {
        event.preventDefault(); // Prevent the browser from opening the dropped item as a file
  
        const file = event.dataTransfer?.files[0];
        const fileSize = event.dataTransfer?.files[0].size / 1024
        this.$emit("getsize", fileSize)
       
        let type = file.type;
        if (
          !(
            type == "image/jpeg" ||
            type == "image/png" ||
            type == "image/jpg" ||
            type == "application/pdf" ||
            type == "application/msword"
          )
        ) {
          this.generateToast("Format not supported", "error");
          return;
        }
  
        if (file.size > 1048576) {
          this.generateToast(
            "Selected image size is too large. Please upload an image smaller than 1MB!",
            "error"
          );
          return;
        }
  
        this.$emit("input", file);
        this.$refs.container.parentElement.style.borderWidth = "2px";
      },
      onDragOver() {
        this.$refs.container.parentElement.style.borderWidth = "4px";
      },
      onDragLeave() {
        this.$refs.container.parentElement.style.borderWidth = "2px";
      },
      selectImage() {
        this.$refs.fileInput.click();
      },
      removeImage() {
        this.previewImage = null;
        this.$emit("remove-image");
      },
      pickFile() {
        let input = this.$refs.fileInput;
        let file = input?.files;
        const fileSize = file[0]?.size / 1024
        this.$emit("getsize", fileSize)

        if (file && file[0].size > 1048576) {
          this.generateToast(
            "Selected image size is too large. Please upload an image smaller than 1MB!",
            "error"
          );
        } else {
          if (file && file[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
              this.previewImage = e.target.result;
            };
            reader.readAsDataURL(file[0]);
            this.$emit("input", file[0]);
          }
        }
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .imagePreviewWrapper {
    @apply text-center;
  }
  
  .file-input {
    display: none;
  }
  </style>
  